module.exports = __webpack_public_path__ + "img/active_9.c0a9ef8a.png";